import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "rentalReturnNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.RENTAL_RETURN.fullString,
    hasInputLabel: true,
  },
];
